import {db} from "../Database/handwaiDB.js";

/***
 * Save the ai results in the db['ai'].
 */
export async function saveAIOutput(annotation, lvDocument) {
    db.ai.put({
        unique_id: 'unique_id',
        annotation_data: annotation,
        lv_document: lvDocument
    });
}

export async function saveAITracking(trackInfo) {
    //console.log(trackInfo)
    db.aiTrack.put({
        unique_id: 'unique_id',
        trackingInfo:trackInfo
    });
}


export async function getAITracking() {
    try {
        return await db.aiTrack.toArray();

    } catch (error) {
        console.log(error);
    }
}


/***
 * Gets the ai results from the db['ai'].
 */
export async function getAIOutputDB() {
    try {
        return await db.ai.toArray();

    } catch (error) {
        console.log(error);
    }
}

export function setAnnotationDB(annotation) {
    (async () => {
        try {
            await db.annotations.put({
                unique_id: annotation.unique_id,
                annotation_data: annotation
            });
        } catch (error) {
            console.log(error);
        }
    })();

}


export async function getAnnotationsDB(annotationID) {
    let result;

    try {
        const result1 = await db.annotations.where("unique_id").equals(annotationID).toArray(
            function (annotations) {
                result = JSON.stringify(annotations)
                return result;
            }
        );

        return JSON.parse(result1.toString())

    } catch (error) {
        console.log(error);
    }
}

export async function getAllAnnotationsDB() {

    let result;

    try {
        const result1 = await db.annotations.toArray(
            function (annotations) {
                result = JSON.stringify(annotations)
                return result;
            }
        );

        return JSON.parse(result1.toString())

    } catch (error) {
        console.log(error);
    }
}

export function removeAnnotationDB(annotationID) {
    (async () => {
        try {
            await db.annotations.delete(annotationID);
        } catch (error) {
            console.log(error);
        }
    })();

}

export function removeAllAnnotationsDB() {

    (async () => {
        try {
            await db.annotations.clear();
        } catch (error) {
            console.log(error);
        }
    })();

}